import { Component, Input, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { FormGroup } from '@angular/forms';
import { DocumentsSectionData } from '../../form-details.model';

@Component({
    selector: 'ifbp-form-details-section',
    templateUrl: './form-details-section.component.html',
    styleUrls: ['./form-details-section.component.scss'],
    standalone: false
})
export class FormDetailsSectionComponent {
  @ViewChild('accordion') accordion: MatAccordion;

  @Input()
  submissionForm: FormGroup;

  @Input()
  documentsData: DocumentsSectionData;

  onClickExpandAll(): void {
    this.accordion.openAll();
  }

  onClickCollapseAll(): void {
    this.accordion.closeAll();
  }
}
